<template>
  <div>
    <template>
      <div>
        <v-breadcrumbs
          :items="breadcrumb"
          class="px-0 pt-0"
        >
        </v-breadcrumbs>
      </div>
    </template>
    <router-link
      to="/bank-admin"
      class="text-decoration-none text-subtitle-2 font-weight-bold"
    >
      <v-icon
        color="primary"
        dense
        class="mr-2"
      >
        {{ icons.mdiArrowLeft }}
      </v-icon>
      Kembali
    </router-link>
    <h3 class="my-8">
      Edit Bank Soal
    </h3>
    <v-card class="pa-4">
      <v-card-text>
        <div class="mb-8">
          <h3>
            Informasi Bank Soal
          </h3>
          <span>
            Informasi untuk bank soal
          </span>
        </div>
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <div>
              <v-text-field
                v-model="questionBank.name"
                :rules="[validation.required]"
                outlined
                dense
                label="Judul Bank Soal"
              ></v-text-field>
            </div>
          </v-col>

          <v-col
            xl="6"
            lg="6"
            md="6"
            sm="12"
            cols="12"
            class="py-0"
          >
            <div>
              <v-autocomplete
                v-model="questionBank.bank_category_uuid"
                :items="categories"
                outlined
                :rules="[validation.required]"
                dense
                item-value="uuid"
                item-text="name"
                label="Kategori"
              ></v-autocomplete>
            </div>
          </v-col>
          <v-col
            xl="6"
            lg="6"
            md="6"
            sm="12"
            cols="12"
            class="py-0"
          >
            <div>
              <v-autocomplete
                v-model="questionBank.level"
                :rules="[validation.required]"
                outlined
                :items="levels"
                item-text="name"
                dense
                item-value="uuid"
                label="Tingkatan"
              ></v-autocomplete>
            </div>
          </v-col>
        </v-row>
        <div class="mb-8">
          <div class="mb-6 mt-6">
            <h3>Icon</h3>
            <span>Icon untuk materi pelajaran</span>
          </div>
          <div class="d-flex mb-10">
            <v-card
              width="120"
              height="110"
              class="d-flex align-center justify-center"
              style="border: 1px dashed #959595;"
              @click="addIcon"
            >
              <div class="text-center">
                <v-icon
                  v-if="!questionBank.icon"
                  large
                >
                  {{ icons.mdiPlus }}
                </v-icon>
                <v-img
                  v-else
                  v-model="questionBank.bank_icon_uuid"
                  :rules="[validation.required]"
                  width="40"
                  :src="questionBank.icon"
                  class="mx-auto"
                ></v-img>
              </div>
            </v-card>
            <div class="ml-4">
              <h4 class="font-weight-light">
                Icon akan ditampilkan di halaman bank soal
              </h4>
              <h4 class="primary--text mb-10">
                Pilih Icon
              </h4>
              <small>*Icon akan dipilih secara default jika anda ingin melewatkannya</small>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <div class="mb-8">
            <h3>
              Status Soal
            </h3>
            <span>
              Kamu dapat menempatkan soal ke dalam beberapa pilihan di bawah
            </span>
          </div>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <div>
                <v-autocomplete
                  v-model="questionBank.type"
                  :rules="[validation.required]"
                  outlined
                  dense
                  :items="types"
                  label="Status Soal"
                  class="mb-0"
                ></v-autocomplete>
              </div>
            </v-col>
          </v-row>
        </div>

        <v-alert
          text
          color="info"
        >
          <p><strong>Keterangan</strong></p>
          <strong>Private</strong> : Soal hanya dapat dilihat Guru, <strong>Public</strong> : Soal dapat dilihat seluruh sekolah yang ada di Literasia, <strong>Sekolah</strong> : Soal hanya dapat dilihat oleh Sekolah Guru, <strong>Kabupaten</strong> : Soal hanya dapat dilihat Sekolah seluruh Kabupaten, <strong>Provinsi</strong> : Soal hanya dapat dilihat Sekolah seluruh Provinsi.
        </v-alert>
        <v-card-actions class="justify-center">
          <v-btn
            color="primary"
            large
            :loading="isLoadingButton"
            :disabled="!formValidLesson"
            @click="update(questionBank.uuid)"
          >
            Update
          </v-btn>
          <v-btn
            color="primary"
            outlined
            large
            @click="returnBack"
          >
            Batal
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <ModalDialog
      :visible="modalDialogIcon"
      :width="500"
      :hidden-actions="false"
      header="Pilih Icon"
      @close-modal="handlerButton"
      @close="modalDialogIcon = false"
    >
      <template v-slot:body>
        <p>Pilih salah satu icon:</p>
        <v-row>
          <v-col
            v-for="bankIcon in bankIcons"
            :key="bankIcon.icon"
            cols="3"
          >
            <v-card
              height="80"
              outlined
              class="pa-4 elevation-0 d-flex justify-center align-center"
              clickable
              :color="cardActive == bankIcon.uuid ? 'primary border-none' : ''"
              @click="getIcon(bankIcon.icon, bankIcon.uuid)"
            >
              <div>
                <v-img
                  width="40"
                  :src="bankIcon.icon"
                  class="mx-auto"
                ></v-img>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:footer>
        <v-btn
          color="primary"
          dense
          large
          @click="chooseIcon(icon.icon, icon.uuid)"
        >
          Pilih
        </v-btn>
        <v-btn
          color="primary"
          dense
          large
          outlined
          @click="handlerButton"
        >
          Batal
        </v-btn>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import ModalDialog from '@/views/components/ModalDialog.vue'
import { integerValidator, required } from '@core/utils/validation'
import { mdiArrowLeft, mdiPlus } from '@mdi/js'

export default {
  name: 'BankQuestionAdd',
  components: {
    ModalDialog,
  },
  data() {
    return {
      icons: { mdiPlus, mdiArrowLeft },
      validation: {
        required,
        integerValidator,
      },
      categories: [],
      required: '',
      rules: {
        required: value => !!value || 'harus diisi',
      },
      types: ['Umum', 'Sekolah', 'Kabupaten', 'Provinsi'],
      sorts: ['Semua', 'Terbaru', 'Banyak Soal', 'Sedikit Soal', 'A-Z', 'Z-A'],
      levels: [],
      levels_selected: [],
      school: [],
      school_uuid: '',
      employee_uuid: '',
      questionsBank: [],
      questionBank: {
        bank_category_uuid: '',
        bank_icon_uuid: '',
        name: '',
        type: '',
        level: '',
      },
      icon: {
        uuid: '',
        icon: '',
      },
      level: [],
      breadcrumb: [
        {
          text: 'Bank Soal',
          disabled: false,
          href: '/bank-admin',
        },
        {
          text: 'Edit Bank Soal',
          disabled: true,
        },
      ],
      role: '',
      bankIcons: [],
      modalDialogIcon: false,
      cardActive: '',
      isLoadingButton: false,
      isDisabledButton: false,
      formValidLesson: false,
    }
  },
  watch: {
    questionBank: {
      handler() {
        const valid = []
        const requiredField = ['name', 'type', 'level', 'icon', 'bank_category_uuid']
        Object.entries(this.questionBank).forEach(([key, item]) => {
          if (requiredField.includes(key)) valid.push(!!(item && item.length))
        })
        this.formValidLesson = !valid.includes(false)
      },
      deep: true,
    },
  },
  mounted() {
    this.getSchoolUuid()
    this.getRole()
    this.listCategories()
    this.listBankIcon()
    this.getLevel()
    this.getBankQuestion(this.$route.params.uuid)
  },
  methods: {
    validate() {
      this.validate()
    },
    returnBack() {
      this.$router.back()
    },
    async getBankQuestion(uuid) {
      await this.$services.ApiServices.get('questionbank', uuid).then(({ data }) => {
        this.questionBank = data.data
        this.questionBank.bank_category_uuid = data.data.category.uuid
        this.questionBank.icon = data.data.bank_icon.icon
        this.cardActive = data.data.bank_icon.uuid
      })
    },
    async listCategories(params = {}) {
      await this.$services.ApiServices.list('bankcategory', { ...params, per_page: 'all' }).then(
        ({ data }) => {
          this.categories = data.data
        },
        err => console.error(err),
      )
    },

    chooseIcon(icon, uuid) {
      this.questionBank.icon = icon
      this.questionBank.bank_icon_uuid = uuid
      this.modalDialogIcon = false
    },
    addIcon() {
      this.modalDialogIcon = true
    },
    getIcon(icon, uuid) {
      this.icon.icon = icon
      this.icon.uuid = uuid
      this.cardActive = uuid
    },
    async listBankIcon() {
      await this.$services.ApiServices.list('bankicon').then(
        ({ data }) => {
          this.bankIcons = data.data
        },
        err => console.error(err),
      )
    },
    getSchoolUuid() {
      this.school = JSON.parse(localStorage.getItem('user')).user.details
      this.school.forEach(el => {
        if (el.school === undefined) {
          this.questionBank.school_uuid = el.uuid

          return
        }
        if (el.school === null) {
          this.showSnackbar({
            text: "You don't have access to this page",
            color: 'error',
          })

          return
        }
        this.school_uuid = el.school.uuid
        this.employee_uuid = el.uuid
      })

      return true
    },
    getRole() {
      this.role = JSON.parse(localStorage.getItem('user')).user.role
      if (this.role === 'admin') {
        this.school_uuid = null
        this.employee_uuid = null
      }
    },
    getLevel() {
      this.level = JSON.parse(localStorage.getItem('user')).user.details
      this.role = JSON.parse(localStorage.getItem('user')).user.role
      if (this.role !== 'admin') {
        this.level.forEach(el => {
          if (el.school.jenjang === 'SD') {
            this.levels = ['Kelas 1 SD', 'Kelas 2 SD', 'Kelas 3 SD', 'Kelas 4 SD', 'Kelas 5 SD', 'Kelas 6 SD']
          } else if (el.school.jenjang === 'SMP') {
            this.levels = ['Kelas 1 SMP', 'Kelas 2 SMP', 'Kelas 3 SMP']
          } else if (el.school.jenjang === 'SMA') {
            this.levels = ['Kelas 1 SMA', 'Kelas 2 SMA', 'Kelas 3 SMA']
          } else if (el.school.jenjang === 'SMK') {
            this.levels = ['Kelas 1 SMK', 'Kelas 2 SMK', 'Kelas 3 SMK']
          }
        })
      } else {
        this.levels = [
          'Semua',
          'Kelas 1 SD',
          'Kelas 2 SD',
          'Kelas 3 SD',
          'Kelas 4 SD',
          'Kelas 5 SD',
          'Kelas 6 SD',
          'Kelas 1 SMP',
          'Kelas 2 SMP',
          'Kelas 3 SMP',
          'Kelas 1 SMA',
          'Kelas 2 SMA',
          'Kelas 3 SMA',
        ]
      }
    },
    async update(uuid) {
      this.isLoadingButton = true
      this.isDisabledButton = true
      this.formData = new FormData()
      this.formData.append('name', this.questionBank.name)
      this.formData.append('bank_category_uuid', this.questionBank.bank_category_uuid)
      this.formData.append('bank_icon_uuid', this.questionBank.bank_icon_uuid)
      this.formData.append('type', this.questionBank.type)
      this.formData.append('level', this.questionBank.level)
      await this.$services.ApiServices.update('questionbank', this.formData, uuid).then(
        ({ data }) => {
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.isLoadingButton = false
          this.isDisabledButton = false
        },
        err => {
          this.isLoadingButton = false
          console.error(err)
        },
      )
      this.returnBack()
    },
    handlerButton() {
      this.questionBank.icon = null
      this.questionBank.bank_icon_uuid = null
      this.modalDialogIcon = false
      this.cardActive = ''
      this.getBankQuestion(this.$route.params.uuid)
    },
    showSnackbar(snackbarData) {
      this.$store.dispatch('snackbar/showSnackbar', snackbarData)
    },
  },
}
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>
